<!-- app/frontend/Components/UI/StickyActionBar.vue -->
<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useBreakpoint } from '@/composables/useBreakpoint'
import { useStickyBar } from '@/composables/useStickyBar'

const { isDesktop } = useBreakpoint()
const bar = useStickyBar()

onMounted(bar.register)
onUnmounted(bar.unregister)
</script>

<template>
  <div
    :class="[
      'flex items-center gap-3 px-4 py-3 bg-[color:var(--surface)]',
      isDesktop
        ? 'static mt-4 rounded-[var(--radius-button)] border border-[color:var(--line)]'
        : 'fixed inset-x-0 bottom-0 z-30 border-t border-[color:var(--line)] pb-[max(env(safe-area-inset-bottom),0.75rem)] shadow-[0_-8px_24px_color-mix(in_oklab,var(--ink)_8%,transparent)]'
    ]"
  >
    <div class="flex-1 min-w-0">
      <slot name="info" />
    </div>
    <div class="shrink-0 flex items-center gap-2">
      <slot />
    </div>
  </div>
</template>
